import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <div className="max-w-4xl mx-auto px-6 py-24">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Política de Privacidad</h1>
        
        <div className="prose prose-lg max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Información que recopilamos</h2>
            <p className="text-gray-700 mb-4">
              En ASISTEC recopilamos información personal que usted nos proporciona directamente cuando:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
              <li>Solicita un presupuesto o información sobre nuestros servicios</li>
              <li>Se suscribe a nuestro boletín de noticias</li>
              <li>Se pone en contacto con nosotros por teléfono, email o WhatsApp</li>
              <li>Utiliza nuestros servicios de construcción y reformas</li>
            </ul>
            <p className="text-gray-700">
              La información puede incluir: nombre, dirección de correo electrónico, número de teléfono, dirección postal y detalles del proyecto.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Uso de la información</h2>
            <p className="text-gray-700 mb-4">
              Utilizamos la información recopilada para:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Proporcionar y mejorar nuestros servicios de construcción y reformas</li>
              <li>Responder a sus consultas y solicitudes de presupuesto</li>
              <li>Enviarle información sobre nuestros servicios y promociones (si ha dado su consentimiento)</li>
              <li>Cumplir con obligaciones legales y contractuales</li>
              <li>Mejorar la experiencia del usuario en nuestro sitio web</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Base legal para el tratamiento</h2>
            <p className="text-gray-700">
              El tratamiento de sus datos personales se basa en:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Su consentimiento explícito</li>
              <li>La ejecución de un contrato en el que usted es parte</li>
              <li>El cumplimiento de obligaciones legales</li>
              <li>Nuestro interés legítimo en mejorar nuestros servicios</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Compartir información</h2>
            <p className="text-gray-700 mb-4">
              No vendemos ni alquilamos su información personal a terceros. Podemos compartir su información con:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Proveedores de servicios que nos ayudan a operar nuestro negocio</li>
              <li>Autoridades legales cuando sea requerido por ley</li>
              <li>Subcontratistas necesarios para completar su proyecto (con su consentimiento)</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Seguridad de los datos</h2>
            <p className="text-gray-700">
              Implementamos medidas de seguridad técnicas y organizativas apropiadas para proteger su información personal contra acceso no autorizado, alteración, divulgación o destrucción.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Sus derechos</h2>
            <p className="text-gray-700 mb-4">
              Bajo el RGPD, usted tiene derecho a:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Acceder a sus datos personales</li>
              <li>Rectificar datos inexactos o incompletos</li>
              <li>Solicitar la eliminación de sus datos</li>
              <li>Oponerse al tratamiento de sus datos</li>
              <li>Solicitar la limitación del tratamiento</li>
              <li>Portabilidad de los datos</li>
              <li>Retirar su consentimiento en cualquier momento</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Retención de datos</h2>
            <p className="text-gray-700">
              Conservamos su información personal solo durante el tiempo necesario para cumplir con los fines para los que fue recopilada, incluyendo requisitos legales, contables o de informes.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Cookies</h2>
            <p className="text-gray-700">
              Nuestro sitio web utiliza cookies para mejorar su experiencia. Para más información, consulte nuestra Política de Cookies.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Contacto</h2>
            <p className="text-gray-700 mb-4">
              Para ejercer sus derechos o si tiene preguntas sobre esta política de privacidad, puede contactarnos:
            </p>
            <ul className="list-none text-gray-700 space-y-2">
              <li><strong>Email:</strong> correodeasistecsl@gmail.com</li>
              <li><strong>Teléfono:</strong> 628 752 701</li>
              <li><strong>WhatsApp:</strong> 628 752 701</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Cambios en esta política</h2>
            <p className="text-gray-700">
              Nos reservamos el derecho de actualizar esta política de privacidad en cualquier momento. Los cambios entrarán en vigor inmediatamente después de su publicación en esta página.
            </p>
          </section>

          <p className="text-gray-600 text-sm mt-12">
            Última actualización: Enero 2025
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
}
